import defineActionTypes from 'helpers/defineActionTypes';

// Define action types
export default defineActionTypes('authentication', [
  'AUTHENTICATION_START',
  'AUTHENTICATION_SUCCESS',
  'AUTHENTICATION_ERROR',
]);



// WEBPACK FOOTER //
// state/authentication/types.js